import { ICrop, isArrayEmpty, labels, nutrition } from "./omnia"
import { IDashboardNutritionNmax, IDashboardService } from "./types"

import RegionId = omnia.models.RegionId

export function getNMaxGroupName(nmax: IDashboardNutritionNmax, svc: IDashboardService) {

    const scotland = (svc.holding.Region == RegionId.Scotland);

    let name: string = null

    if (scotland) {

        const mainCrop = getMainCropFromCropping(nmax.Cropping, svc)

        name = mainCrop
            ? (mainCrop.Grass ? "Grass" : mainCrop.Name)
            : null

    }

    return name || labels.NMaxGroupId(nmax.GroupId) || nmax.GroupName


}

export function getMainCropFromCropping(ids: number[], svc: IDashboardService): ICrop {

    if (isArrayEmpty(ids)) {
        return null
    }

    const cropping = svc.getFieldService().cropping.filter(c => ids.indexOf(c.croppingId) >= 0).map(c => c.cropping)

    return nutrition.getMainCropForNmaxGroup(cropping)

}
